import { render, staticRenderFns } from "./finish_details.vue?vue&type=template&id=a0ef200a&scoped=true&"
import script from "./finish_details.vue?vue&type=script&lang=js&"
export * from "./finish_details.vue?vue&type=script&lang=js&"
import style0 from "./finish_details.vue?vue&type=style&index=0&id=a0ef200a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ef200a",
  null
  
)

export default component.exports